import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRowingNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M10.12 12.79l-1.41 2.65h-.58l-.72 1.35h.58l-3.31 6.23h1.53l3.31-6.23h.58l.72-1.35h-.58l.64-1.21zM15.91.33L14.09 3.8a6.711 6.711 0 00-.75 2.55c-.02.14-.02.28-.03.43l-1.06 2.01.76 1.44 1.39-2.61c.209-.02.416-.053.62-.1a4.948 4.948 0 003.34-2.57L20.72.33zm1.25 4.01a3.525 3.525 0 01-2.45 1.87c.09-.624.282-1.23.57-1.79l1.44-2.75h1.8z" />
        <path d="M4.77 4.95a4.883 4.883 0 003.97 2.67l4.15 7.82h-.58l.72 1.35h.58l3.31 6.23h1.53l-3.31-6.23h.58L15 15.44h-.58l-1.55-2.92v-.01L9.82 6.78c0-.09-.012-.19-.02-.28a7.085 7.085 0 00-.76-2.7L7.22.33H2.41zm3.08-.53c.288.56.48 1.166.57 1.79a3.546 3.546 0 01-2.45-1.87L4.61 1.67h1.8z" />
      </g>
    </svg>
  )
);
SvgSportsRowingNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsRowingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRowingNormalSmall;
